import { BASE_URL } from "../api/baseURL";

export const renderHtmlWithLineBreaks = (text) => {
    return text
      ?.split("<br/>")
      ?.map((each) => <div className="min-h-3 mt-2 max767:not-italic max767:font-normal max767:leading-6">{each}</div>);
  };


  export const attachStrapiBaseUrl = (url) => { 
    return BASE_URL+url
  }